import type { FC } from 'react';

import type { RenderFilterProps } from './types';

// Registry to break circular dependency between FilterComponent and FilterGroup
// FilterComponent registers itself here, and FilterGroup uses it from here
let registeredFilterComponent: FC<RenderFilterProps> | null = null;

export const registerFilterComponent = (component: FC<RenderFilterProps>): void => {
  registeredFilterComponent = component;
};

export const getFilterComponent = (): FC<RenderFilterProps> => {
  if (!registeredFilterComponent) {
    throw new Error('FilterComponent not registered. Ensure FilterComponent is imported before FilterGroup is used.');
  }

  return registeredFilterComponent;
};
